import React, { useState } from "react";
import axios from "axios";
import { InputField, Button } from "@cakrawalajakarta/shared-components";

export const VoucherInput = ({ onApplyVoucher, disabled, eventId, kategori, children, onCodeChange }) => {
  const [voucherCode, setVoucherCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const [appliedCode, setAppliedCode] = useState("");

  const handleApply = async () => {
    setMessage("");
    if (!voucherCode) {
      setMessage("Please enter a voucher code.");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_API_BASE_URL}/api/validate-voucher`,
        { code: voucherCode, eventId, kategori }
      );
      const { discountType, discountValue, discountPercentage } = response.data;
      
      // Support both new (discountType/discountValue) and legacy (discountPercentage) format
      const type = discountType || "percentage";
      const value = discountValue !== undefined ? discountValue : discountPercentage;
      
      onApplyVoucher(voucherCode, value, type);
      setAppliedCode(voucherCode);
      
      if (type === "fixed") {
        setMessage(`Voucher applied successfully! Discount Rp ${value.toLocaleString('id-ID')}`);
      } else {
        setMessage(
          value === 100
            ? "No way… you just hacked the system. Discount 100% applied!"
            : `Voucher applied successfully! Discount ${value}%`
        );
      }
    } catch (err) {
      setMessage(err.response?.data?.message || "Invalid voucher code.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col my-4">
      {/* Label */}
      <label className="text-slate-800 font-medium mb-1">Voucher Code</label>

      {/* Input + Buttons Responsive Container */}
      <div className="flex flex-col md:flex-row gap-3 md:gap-4">
        <div className="w-full md:flex-1">
          <InputField
            type="text"
            value={voucherCode}
            onChange={(e) => {
                const val = e.target.value.toUpperCase();
                setVoucherCode(val);
                setMessage("");
                if (onCodeChange) onCodeChange(val);
            }}
            placeholder="Enter voucher code"
            disabled={disabled || loading}
          />

        </div>
        
        {/* Buttons Row */}
        <div className="flex gap-2 w-full md:w-auto">
          <Button
            type="button"
            onClick={handleApply}
            loading={loading}
            disabled={disabled}
            className="flex-1 md:flex-none md:w-[120px]"
          >
            Apply
          </Button>
          
          {/* Children Wrapper for responsive width */}
          <div className="flex-1 md:flex-none flex [&>button]:w-full md:[&>button]:w-auto">
             {children}
          </div>
        </div>
      </div>

      {/* Pesan & Warning */}
      {message ? (
        <p
          className={`mt-4 text-sm ${
            message.includes("berhasil") || message.includes("hacked") || message.includes("successfully")
              ? "text-green-600"
              : "text-rose-600"
          }`}
        >
          {message}
        </p>
      ) : (voucherCode && voucherCode !== appliedCode) && (
        <p className="mt-4 text-sm text-amber-600">
           Click <strong>Apply</strong> to use voucher code.
        </p>
      )}
    </div>
  );
};
